// extracted by mini-css-extract-plugin
export default {"testPageStage":"testPage_testPageStage__vfiO8"};